import React from 'react';
import {
  Dimensions, ImageBackground, ImageSourcePropType, StyleProp,
  StyleSheet, ViewStyle,
} from 'react-native';
const { width } = Dimensions.get('window');

interface IProps {
  source: ImageSourcePropType;
  containerStyle?: StyleProp<ViewStyle>;
}

export const SliderImage = ({ source, containerStyle }: IProps) => {
  return (
    <ImageBackground source={source} style={[styles.container, containerStyle]} />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width,
  },
});
